import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Add the cursor-based radial gradient effect
document.addEventListener('mousemove', (event) => {
  const x = event.clientX / window.innerWidth;
  const y = event.clientY / window.innerHeight;
  const gradient = `radial-gradient(at ${x * 100}% ${y * 100}%, #20508a, #112D4E)`;
  document.body.style.background = gradient;
});

reportWebVitals();
